import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom";
import { setIntendedPath } from "../../redux-stores/slices/layoutSlice";
import { INIT_IG_AUTH_ROUTE } from "../../constants/constants";

interface InsufficientPermissionsCTAProps {
    feature: string,
    missing_permissions: {
        [key: string]: string,
    },
    intended_url?: string
}
const InsufficientPermissionsCTA: React.FC<InsufficientPermissionsCTAProps>
    = ({ missing_permissions, feature, intended_url }) => {

        const dispatch = useDispatch();
        const location = useLocation();
        const navigate = useNavigate();

        const getMissingPermissions = () => {
            if (missing_permissions) {
                return Object.values(missing_permissions)
            }
            return [];
        }

        const reauthorize = async () => {
            dispatch(setIntendedPath(intended_url ?? location.pathname + location.search));
            navigate(INIT_IG_AUTH_ROUTE+'?feature=' + feature);
        }

        return (
            <div className="card rounded-4 shadow-none border-danger" style={{ border: '1px dashed' }}>
                <div className="card-body d-flex flex-column">
                    <h3 className="text-dark">
                        Review Instagram Connection
                    </h3>
                    <p className="mb-2">Your connection is missing the permissions to use this feature.</p>
                    {
                        getMissingPermissions().map((permission, i) => {
                            return (
                                <p key={i} className="fw-bold mb-0">{permission}</p>
                            )
                        })
                    }
                    <button onClick={reauthorize} className="btn btn-primary btn-sm rounded-4 mt-3">Review Connection</button>
                </div>
            </div>
        )
    }

export default InsufficientPermissionsCTA